export enum ActiveDirectoryCredentialState {
	Unknown = 0,
	Valid = 1,
	Invalid = 2,
	CannotConnect = 3,
	AccountBlocked = 4,
	PasswordHasExpired = 5,
	NonePresent = 6
}

export enum LoginPasswordDialogType {
	None = 1,
	VerifyPassword = 3
}

export enum WelcomeWizardStepKind {
	Culture = 1,
	Billing = 2,
	Documents = 3,
	PersonalInfo = 4,
	ProfessionalInfo = 5,
	UserPreferences = 6,
	AdditionalInfo = 7
}

export type AuthenticatedUserSettings = {
	requestChangePassword: boolean;
	showWelcomeScreen: boolean;
	welcomeScreenFormStep: WelcomeWizardStepKind;
	activeDirectoryCredentialState: ActiveDirectoryCredentialState;
};

export type LoginEventsSettingsModel = {
	authenticatedUserSettings: AuthenticatedUserSettings;
	passwordDialogType: LoginPasswordDialogType;
	hideWelcomeScreen: boolean;
	hasCultureConfigured: boolean;
	previouslyDetectedTimeZone: string | null;
	timeZone: string | null;
	hasTimeZoneAutomaticallySet: boolean;
};

export type SignOutModel = {
	redirectUrl: string;
	intercomAppId: string | null;
};
